var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-light-svg-icons/faSearch';
import style from './HeaderSearch.module.scss';
import { useAperzaUserContext } from './AperzaUserContext';
import AppConfig from '../utils/AppConfig';
import AppService from '../utils/AppService';
import { PathUtil } from '../utils/PathUtil';
import AppConfigService from '../utils/AppConfigService';
export function HeaderSearch(_a) {
    var _this = this;
    var _b;
    var suggestKeyword = _a.suggestKeyword, onSuggestChange = _a.onSuggestChange;
    var serviceType = useAperzaUserContext().serviceType;
    var _c = useState((_b = (onSuggestChange ? suggestKeyword : AppConfigService.getSearchKeyword())) !== null && _b !== void 0 ? _b : ''), keyword = _c[0], setKeyword = _c[1];
    var searchPlaceholder = 'アペルザに登録された8600社を超える企業の製品、カタログ、動画を検索';
    switch (serviceType) {
        case AppConfig.APERZA_CATALOG:
            searchPlaceholder = '8600社から5万点以上のカタログを検索';
            break;
        case AppConfig.APERZA_EC:
            searchPlaceholder = 'アペルザECで販売されている120万点以上の製品を検索できます';
            break;
        case AppConfig.APERZA_NEWS:
            searchPlaceholder = '製造業のニュースから検索';
            break;
        case AppConfig.APERZA_TV:
            searchPlaceholder = 'アペルザTVで配信されている700本以上の動画から検索';
            break;
        default:
            break;
    }
    function getOrigin() {
        if (window.location) {
            var origin_1 = window.location.origin;
            if (!origin_1) {
                return (window.location.protocol +
                    '//' +
                    window.location.hostname +
                    (window.location.port ? ':' + window.location.port : ''));
            }
            return origin_1;
        }
        return '';
    }
    var onSelect = function (val) { return __awaiter(_this, void 0, void 0, function () {
        var pathname, origin_2, langCode, encodedVal, url;
        return __generator(this, function (_a) {
            if (val && val.length > 0) {
                pathname = window.location.pathname;
                origin_2 = getOrigin();
                langCode = 'ja';
                encodedVal = encodeURIComponent(val);
                url = '#';
                switch (serviceType) {
                    case AppConfig.APERZA_CATALOG:
                        url = "".concat(AppService.wwwServerHost(), "/").concat(langCode, "/s/catalog/?k=").concat(encodedVal, "&rf=1110&ss=1");
                        break;
                    case AppConfig.APERZA_EC:
                        url = "".concat(AppService.ecServerHost(), "/s/item/?k=").concat(encodedVal, "&rf=1112&ss=1");
                        break;
                    case AppConfig.APERZA_NEWS:
                        url = "".concat(origin_2, "/?s=").concat(encodedVal);
                        break;
                    case AppConfig.APERZA_TV:
                        url = "".concat(AppService.tvServerHost(), "/search/?k=").concat(encodedVal);
                        break;
                    default: {
                        if (PathUtil.isSearchCatalogPage(pathname, langCode)) {
                            url = "".concat(AppService.wwwServerHost(), "/").concat(langCode, "/s/catalog/?k=").concat(encodedVal, "&rf=1110&ss=1");
                        }
                        else if (pathname.startsWith("/".concat(langCode, "/s/news/"))) {
                            url = "".concat(AppService.wwwServerHost(), "/").concat(langCode, "/s/news/?k=").concat(encodedVal, "&rf=1113&ss=1");
                        }
                        else {
                            url = "".concat(AppService.wwwServerHost(), "/").concat(langCode, "/s/model/?k=").concat(encodedVal, "&rf=1109&ss=1");
                        }
                        break;
                    }
                }
                window.location.href = url;
            }
            return [2 /*return*/];
        });
    }); };
    var onClickSuggestButton = function () { return __awaiter(_this, void 0, void 0, function () {
        var val;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!keyword) return [3 /*break*/, 2];
                    val = keyword;
                    return [4 /*yield*/, onSelect(val.trim())];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        setKeyword(suggestKeyword !== null && suggestKeyword !== void 0 ? suggestKeyword : '');
    }, [suggestKeyword]);
    var onChange = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var updatedKeyword;
        var _a;
        return __generator(this, function (_b) {
            updatedKeyword = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value;
            setKeyword(updatedKeyword || '');
            if (onSuggestChange) {
                onSuggestChange(updatedKeyword);
            }
            return [2 /*return*/];
        });
    }); };
    var onInputKeyPress = function (e) {
        if (e.code === 'Enter') {
            onClickSuggestButton();
        }
    };
    return (_jsxs("div", __assign({ className: style.searchBox }, { children: [_jsx("input", { type: "search", className: style.searchInput, placeholder: searchPlaceholder, "aria-label": "Search", value: keyword, onChange: onChange, onKeyPress: onInputKeyPress }), _jsx("button", __assign({ onClick: onClickSuggestButton, className: style.searchButton, type: "button" }, { children: _jsx(FontAwesomeIcon, { icon: faSearch }) }))] })));
}
